import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { initState, ParticipationsData, VerifiedCustomer, DocumentType, Campaign } from './types';

const initialState: initState = {
  list: {
    data: [],
    meta: {
      totalCount: 0,
    },
  },
  verifiedCustomer: null,
  validatedCode: null,
  documentTypes: [],
  campaigns: [],
  selectedCampaignId: null,
};

const customerSupportSlice = createSlice({
  name: 'customerSupport',
  initialState,
  reducers: {
    setCustomerSupportData(state: initState, action: PayloadAction<{ list: ParticipationsData }>) {
      state.list = action.payload.list;
    },
    setVerifiedCustomer(state: initState, action: PayloadAction<{ customer: VerifiedCustomer }>) {
      state.verifiedCustomer = action.payload.customer;
    },
    clearVerifiedCustomer(state: initState) {
      state.verifiedCustomer = null;
    },
    setValidatedCode(state: initState, action: PayloadAction<string>) {
      state.validatedCode = action.payload;
    },
    clearValidatedCode(state: initState) {
      state.validatedCode = null;
    },
    setDocumentTypes(state: initState, action: PayloadAction<DocumentType[]>) {
      state.documentTypes = action.payload;
    },
    setCampaigns(state: initState, action: PayloadAction<Campaign[]>) {
      state.campaigns = action.payload;
    },
    setSelectedCampaignId(state: initState, action: PayloadAction<number | null>) {
      state.selectedCampaignId = action.payload;
    },
  },
});

export const { setCustomerSupportData, setVerifiedCustomer, clearVerifiedCustomer, setValidatedCode, clearValidatedCode, setDocumentTypes, setCampaigns, setSelectedCampaignId } = customerSupportSlice.actions;
export default customerSupportSlice.reducer;
